import { toObject, on, off, renderThumbStyle, BAR_MAP, addResizeListener, removeResizeListener, BarWidth } from './utils';
import Bar from './bar';
import './bar.scss';
export default {
  name: 'ScrollsBar',
  mounted () {
    if (this.native) return;
    this.$nextTick(this.update);

    !this.noresize && addResizeListener(this.$refs.resize, this.update);
  },
  beforeDestroy () {
    if (this.native) return;
    !this.noresize && removeResizeListener(this.$refs.resize, this.update);
  },
  computed: {
    bar () {
      return BAR_MAP['horizontal'];
    },
    wrap () {
      return this.$refs.wrap;
    },
  },
  components: { Bar },
  props: {
    vertical: {
      default: true,
    },
    native: Boolean,
    fineSizeWidth: {
      default: 0,
    },
    overall: {
      default: true,
    },
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    drag: {
      default: false,
    },
    scrollFn: Function,
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div',
    },
  },
  data () {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      sizeHeightScroll: '0',
      horizontalBottom: '0',
      moveX: 0,
      moveY: 0,
      wrapBottom: 50,
    };
  },
  methods: {
    handleScroll () {
      // if (this.scrollFn) this.scrollFn()
      const wrap = this.wrap;
      this.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
      this.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
      // 纵向滚动到底部

      if (wrap.scrollTop > 0 && wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight) {
        this.$emit('handleScrollEnd')
      }
    },
    scrollToTop () {
      this.wrap.scrollTop = 0;
    },
    clickThumbHandler (e) {
      if (e.ctrlKey || e.button === 2) {
        return;
      }
      if (this.overall) {
        this.startDrag(e);
        this[this.bar.axis] = e.x;
      }
    },
    startDrag (e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;
      on(document, 'mousemove', this.mouseMoveDocumentHandler);
      on(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = () => false;
    },
    mouseMoveDocumentHandler (e) {
      if (this.cursorDown === false) return;
      const prePage = e[this.bar.axis.toLowerCase()];
      if (!prePage) return;
      let z = e.x - this[this.bar.axis];
      let pz = 0.01 * (1 - this.sizeWidth.replace('%', '')) * 0.5 * z;
      this.wrap[this.bar.scroll] = pz + this.wrap.scrollLeft;
    },
    mouseUpDocumentHandler (e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      off(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    },
    update (fn) {
      setTimeout(() => {
        let heightPentage, widthPentage;
        const wrap = this.wrap;
        if (!wrap) return;
        heightPentage = (wrap.clientHeight * 100) / wrap.scrollHeight;
        widthPentage = (wrap.clientWidth * 100) / (wrap.scrollWidth + this.fineSizeWidth);
        this.sizeHeight = heightPentage < 100 ? heightPentage + '%' : '';
        this.sizeWidth = widthPentage < 100 ? widthPentage + '%' : '';
        this.sizeHeightScroll = wrap.clientWidth + BarWidth + 'px'
        if (fn) fn()
      }, 800);
    },
  },
  render (h) {
    let gutter = BarWidth();
    // let gutter = 0;
    let style = this.wrapStyle;
    if (gutter) {
      const gutterWidth = `-${gutter}px`;
      const gutterStyle = `margin-bottom: ${gutterWidth};margin-right: ${gutterWidth}`;
      // const gutterStyle = `margin-bottom: ${gutterWidth};`;
      const _this = this;
      // 可配置化设置
      if (Array.isArray(this.wrapStyle)) {
        style = toObject(this.wrapStyle);
        style.marginRight = style.margin.bottom = gutterWidth;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    // 视图
    const view = h(
      this.tag,
      {
        class: ['el-scrollbar__view', this.viewClass],
        style: this.viewStyle,
        on: {
          mousedown: this.drag ? this.clickThumbHandler : () => { },
        },
        ref: 'resize',
      },
      this.$slots.default
    );
    // 视图容器
    // const wrap = (
    //     <div ref='wrap' style={style} onScroll={this.handleScroll} class={[this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollBar__wrap--hidden-default']}>
    //         {[view]}
    //     </div>
    // );
    const wrap = h(
      'div',
      {
        style,
        ref: 'wrap',
        on: { scroll: this.handleScroll },
        class: [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollBar__wrap--hidden-default', this.vertical ? '' : 'no-scroll-y'],
      },
      [view]
    );
    let nodes;
    if (!this.native) {
      nodes = [
        wrap,
        h('Bar', {
          ref: 'horizontal',
          props: {
            move: this.moveX,
            size: this.sizeWidth,
          },
        }),
        this.vertical
          ? h('Bar', {
            ref: 'vertical',
            props: {
              vertical: true,
              move: this.moveY,
              size: this.sizeHeight,
            },
          })
          : '',
      ];
      // nodes = [wrap, <Bar move={this.moveX} size={this.sizeWidth}></Bar>, <Bar vertical move={this.moveY} size={this.sizeHeight}></Bar>];
    } else {
      // nodes = [
      //     <div ref='wrap' class={[this.wrapClass, 'el-scrollBar__wrap']}>
      //         {[view]}
      //     </div>
      // ];
      nodes = h('div', { ref: 'wrap', class: [this.wrapClass, 'el-scrollBar__wrap'] }, [view]);
    }
    return h('div', { class: 'el-scrollbar' }, nodes);
  },
};
